<template>
  <v-app
    id="app"
    light
  >
    <router-view />
    <app-snackbar />
  </v-app>
</template>

<script>
import AppSnackbar from '@/components/AppSnackbar'

export default {
  name: 'App',
  components: { AppSnackbar },
  mounted() {
    this.$store.dispatch('checkAuth')
  }
}
</script>

<style lang="scss">
.v-card__title {
  font-family: $heading-font-family;
}

.v-card__text {
  font-size: 1rem;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--v-darkslategray-base);
  font-family: $heading-font-family;
}

.v-btn {
  font-family: $heading-font-family;
}

// Utility styles brought back from original App-level styles
.display-flex {
  display: flex;
}

.height-100vh {
  height: 100vh;
}

.pos-rel {
  position: relative;
}

.o-auto {
  overflow: auto;
}

.miny-100vh {
  min-height: 100vh;
}

.v-data-table-header th {
  white-space: nowrap;
}
</style>
